<template>
  <data-cell-text
    v-bind="$attrs"
    :value="value"
    :item="item"
    :context="context"
    :on-clicked="onEdit"
  />
</template>

<script setup lang="ts">
import DataCellText from "@/components/controls/grid/renderers/DataCellText.vue";
import type { Renderable } from "@/components/controls/grid/BmGridData";
import type { TextTruncationOptions } from "@/components/controls/grid/builder/ColumnBuilders";
import { showModalDialog } from "@/components/platform/common/showModalDialog";
import DataCellInfoDialog from "@/components/controls/grid/renderers/info/DataCellInfoDialog.vue";
import type { Maybe } from "@/components/utils/typeHelpers";

interface DataCellTextInfoProps {
  value?: Maybe<string>;
  item?: unknown;
  context?: Renderable;
}

const props = defineProps<DataCellTextInfoProps>();

async function onEdit() {
  const options: TextTruncationOptions | undefined =
    props.context?.rendererMetadata.textTruncationOptions;

  if (options) {
    const val = props.value ?? "";
    const infoToDisplay = options.fullViewReformat
      ? options.fullViewReformat(val)
      : val;
    // Open using showModalDialog so it doesn't close if the grid updates
    await showModalDialog<void, typeof DataCellInfoDialog>(DataCellInfoDialog, {
      props: {
        infoToDisplay,
      },
      attrs: {
        label: options.title,
        width: options.width,
      },
    });
  }
}
</script>
